module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex border-top-medium border-bottom-medium align-items-center py-2"
  }, [_c('label', {
    staticClass: "fs-large"
  }, [_vm._v("Transport:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flexGrow1 align-items-center"
  }, [_c('div', {
    staticClass: "bold fs-smaller d-flex flex-column flexGrow1 px-2"
  }, _vm._l((_vm.transport.transfers), function(transfer) {
    return (transfer.schedule) ? _c('span', [_vm._v("\n                " + _vm._s((transfer.transportDirection == '1') ? 'Pickup' : 'Dropoff') + ":\n                " + _vm._s(transfer.schedule.timeShort) + "\n                " + _vm._s((transfer.transportDirection == '2') ? _vm.reservation.event.location + ' -' : '') + "\n                " + _vm._s(transfer.stop.name) + "\n                " + _vm._s((transfer.transportDirection == '1') ? '- ' + _vm.reservation.event.location : '') + "\n            ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [(_vm.hasTransport) ? _c('button', {
    staticClass: "btn secondary small",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleEditTransport
    }
  }, [_vm._v("EDIT")]) : (!_vm.hasTransport && _vm.hasEventTransport || _vm.reservation.event.eventRoutes.length > 0) ? _c('button', {
    staticClass: "btn secondary small",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleEditTransport
    }
  }, [_vm._v("ADD")]) : (_vm.reservation.event.eventRoutes.length === 0 && !_vm.hasEventTransport) ? _c('span', {
    staticClass: "fs-small px-2 bold dark cursor-default"
  }, [_vm._v("No transport available")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-c6153ca8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6153ca8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabCustomer/ClientTransport.vue
// module id = 1872
// module chunks = 0